<template>
  <div>
    <Header></Header>
    <Kiwi></Kiwi>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/common/header'
import Kiwi from '@/components/common/kv'
import Footer from '@/components/common/footer'

export default {
  name: 'layout',
  components: {
    Header,
    Kiwi,
    Footer
  }
}
</script>
